"use strict";

export function initInScope ($scope) {
    let $tab = $scope.find('.js-scrolling-tabs__item');

    $tab.each(function () {
        let $this = $(this);

        if ($this.hasClass('active')) {
            calcCenter($this.closest('.nav-item'))
        }

        if ($this.data('toggle')) {
            $this.on('show.bs.tab', function () {
                calcCenter($this.closest('.nav-item'))
            });
        }
    });

    initArrowClick($scope);
}


function calcCenter($this) {
    if($this && $this.length) {
        let childPos = $this.offset().left,
            parentScroll = $this.closest('.js-scrolling-tabs').scrollLeft(),
            offset = childPos + parentScroll - window.outerWidth/2 + $this.width()/2;

        // console.log('childPos',childPos)
        // console.log('parentScroll',parentScroll)
        // console.log('window.outerWidth/2',window.outerWidth/2)
        // console.log('$this.width()/2',$this.width()/2)
        // console.log('offset',offset)
        try {
            // console.log('xxx',$this.closest('.js-scrolling-tabs'))
            $this.closest('.js-scrolling-tabs')[0].scroll({
                left: offset,
                behavior: 'smooth'
            });
        } catch (e) {
            // console.log('yyy');

            $this.closest('.js-scrolling-tabs').stop().animate({
                scrollLeft: offset
            }, 200, 'swing');
        }
    }
}

function initArrowClick($scope) {

    let $scrollingTabs = $scope.find('.js-scrolling-tabs'),
        $scrollingTabsItem = $scope.find('.js-scrolling-tabs__item'),
        $scrollingTabsLeft = $scope.find('.js-scrolling-tabs__arrow-left'),
        $scrollingTabsRight = $scope.find('.js-scrolling-tabs__arrow-right');

    if($scrollingTabsItem.length < 3){
        $scrollingTabsLeft.hide();
        $scrollingTabsRight.hide();
    }

    $scrollingTabs.scrollLeft();

    $scrollingTabsRight.on('click', function (e) {
        $scrollingTabs.animate( {
            scrollLeft: '+=220'
        }, 250,function (e) {
            $scrollingTabsLeft.removeClass('hiding');


            let newScrollLeft = $scrollingTabs.scrollLeft(),
                width=$scrollingTabs.outerWidth(),
                scrollWidth=$scrollingTabs.get(0).scrollWidth;
            if (scrollWidth - newScrollLeft === width) {
                $scrollingTabsRight.addClass('hiding');
            }

        });
    });

    $scrollingTabsLeft.on('click', function (e) {
        $scrollingTabs.animate( {
            scrollLeft: '-=220'
        },function (e) {
            $scrollingTabsRight.removeClass('hiding');
            if($scrollingTabs.scrollLeft() <= 0){
                $scrollingTabsLeft.addClass('hiding');
            }
        });

    });

}